exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".sel-type-item[data-v-41fd66ef] .yxt-radio__label{display:inline-flex;align-items:center}.form-box[data-v-41fd66ef] .yxt-select{width:328px}.form-box[data-v-41fd66ef] .yxt-form-item{margin-bottom:10px}\n", ""]);

